import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const WAM = () => {
  const rules = [
    {
      id: 1,
      title: "Non-Profit Service",
      text: "Al Qaim Welfare Foundation is a non profit organization. All work is voluntary with no salary. Members serve with the intention of qurbatan ilallah, seeking closeness to Allah(s.w.t)",
    },
    {
      id: 2,
      title: "Monthly Membership Contribution",
      text: "Members contribute a minimum of Rs.100 by the 14th of each month to support foundation activities.",
    },
    {
      id: 3,
      title: "Meeting Attendance",
      text: "Each member should attend atleast one meeting per month. Meetings can be joined online or in person.",
    },
    {
      id: 4,
      title: "Volunteer Tasks",
      text: "Members may be assigned tasks based on their availability and skills. Participation is always voluntary.",
    },
    {
      id: 5,
      title: "Commitment and Reminders",
      text: "If you commit to a task with a deadline, the team will send you friendly reminders to help you stay on track.",
    },
    // {
    //   id: 6,
    //   title: "Joining the Foundation",
    //   // text: `To become a member, please contact:\n+91-7738805577\nEmail Address - alqaimwelfareinfo@gmail.com`,
    // },
    { 
  id: 6, 
  title: "Joining the Foundation", 
  text: (
    <>
      To become a member, please{" "}fill this 
      <Link to="/member-agreement" className="form-link">  form.</Link>
    </>
  )
}
  ];

  return (
    <>
      <Navbar />

      <div className="wam-container">
        <div className="table-wrapper">
          <table className="wam-table">
            <thead>
              <tr>
                <th colSpan="2" className="table-header">
                  Al Qaim Welfare Foundation - Membership Guidelines
                </th>
              </tr>
            </thead>

            {/* <tbody>
              {rules.map((rule) => (
                <tr key={rule.id} className="table-row">
                  <td className="title-cell">
                    <span className="rule-title">
                      {rule.id}. {rule.title}
                    </span>
                  </td>

                  <td className="text-cell">
                    {rule.text.split("\n").map((line, index) => (
                      <React.Fragment key={index}>
                        {line}
                        {index < rule.text.split("\n").length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody> */}
            <tbody>
  {rules.map((rule) => (
    <tr key={rule.id} className="table-row">
      <td className="title-cell">
        <span className="rule-title">
          {rule.id}. {rule.title}
        </span>
      </td>
      <td className="text-cell">
        {/* Fix: Check if text is a string before calling .split() */}
        {typeof rule.text === 'string' ? (
          rule.text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index < rule.text.split('\n').length - 1 && <br />}
            </React.Fragment>
          ))
        ) : (
          /* If it is a JSX element (the link component), render it directly */
          rule.text
        )}
      </td>
    </tr>
  ))}
</tbody>
          </table>
        </div>
      </div>

      <ToastContainer />
      <Footer />

      <style jsx>{`
        .wam-container {
          width: 100%;
          padding: 140px 20px 60px;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .table-wrapper {
          width: 100%;
          max-width: 1200px;
          overflow-x: auto;
          border-radius: 12px;
        }

        .wam-table {
          width: 100%;
          border-collapse: collapse;
          font-family: Arial, sans-serif;
          background: #ffffff;
          overflow: hidden;
        }

        .table-header {
          background-color: #162f06;
          color: white;
          padding: 20px;
          font-size: clamp(18px, 2vw, 28px);
          text-align: center;
          border: 1px solid #000;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          line-height: 1.5;
        }

        .table-row {
          transition: 0.3s ease;
        }

        .table-row:hover {
          background: #fafafa;
        }

        .title-cell {
          width: 30%;
          min-width: 240px;
          padding: 22px 18px;
          border: 1px solid #000;
          vertical-align: top;
          background: #f8f8f8;
        }

        .rule-title {
          color: #b3881b;
          font-weight: 700;
          font-size: clamp(15px, 1.4vw, 18px);
          line-height: 1.6;
        }

        .text-cell {
          padding: 22px 20px;
          border: 1px solid #000;
          line-height: 1.9;
          font-size: clamp(14px, 1.2vw, 17px);
          color: #222;
          white-space: pre-line;
        }

        /* ========================= */
        /* LARGE DESKTOPS */
        /* ========================= */

        @media screen and (min-width: 1600px) {
          .wam-container {
            padding: 160px 40px 80px;
          }

          .table-wrapper {
            max-width: 1400px;
          }

          .text-cell {
            font-size: 18px;
          }
        }

        /* ========================= */
        /* LAPTOPS */
        /* ========================= */

        @media screen and (max-width: 1200px) {
          .wam-container {
            padding: 130px 20px 50px;
          }

          .title-cell {
            min-width: 220px;
          }
        }

        /* ========================= */
        /* TABLETS / IPADS */
        /* ========================= */

        @media screen and (max-width: 992px) {
          .wam-container {
            padding: 120px 16px 40px;
          }

          .title-cell,
          .text-cell {
            padding: 18px 16px;
          }

          .table-header {
            font-size: 20px;
          }
        }

        /* ========================= */
        /* MOBILE DEVICES */
        /* ========================= */

        @media screen and (max-width: 768px) {
          .wam-container {
            padding: 110px 12px 30px;
          }

          .wam-table,
          .wam-table tbody,
          .wam-table tr,
          .wam-table td {
            display: block;
            width: 100%;
          }

          .wam-table thead {
            display: table-header-group;
          }

          .table-row {
            margin-bottom: 18px;
            border: 1px solid #ddd;
          }

          .title-cell {
            width: 100%;
            min-width: unset;
            border-bottom: none;
            background: #f4f4f4;
            padding: 16px;
          }

          .text-cell {
            width: 100%;
            border-top: none;
            padding: 16px;
            line-height: 1.7;
          }

          .table-header {
            font-size: 17px;
            padding: 16px 12px;
            line-height: 1.6;
          }

          .rule-title {
            font-size: 15px;
          }
        }

        /* ========================= */
        /* SMALL PHONES */
        /* ========================= */

        @media screen and (max-width: 480px) {
          .wam-container {
            padding: 100px 10px 20px;
          }

          .table-header {
            font-size: 15px;
            padding: 14px 10px;
          }

          .title-cell,
          .text-cell {
            padding: 14px;
          }

          .text-cell {
            font-size: 14px;
            line-height: 1.6;
          }

          .rule-title {
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
};

export default WAM;